import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import UserRoleFormLayer from "../components/UserRoleFormLayer";

const UserRoleFormPage = () => {
  return (
    <>
      <MasterLayout>
        <UserRoleFormLayer />
      </MasterLayout>
    </>
  );
};

export default UserRoleFormPage;
